import { BaseEntity } from "yt-ng-framework";

export class VrstaStavkiView extends BaseEntity{
    constructor(){
        super();
    }

    Sifra: string;
    Naziv: string;
    RobaUsluga: string;
    Cena: number;
    JedinicaMere: string;
    Konto: string;  
    Tarifa: string;
    TarifaID: number;
    JedinicaMereID: number;
  //  OrgJed:string;

    Deserialize(input:any){
    //    super.Deserialize(input); //Potrebno kako bi IsDefault vracao defaultne podatke.
       this.IsDefault = input.IsDefault ? input.IsDefault : false; 
       this.ID=input.ID;
        this.Sifra = input.Sifra;
        this.Naziv= input.Naziv;
        this.RobaUsluga=input.RobaUsluga;
        this.Cena=input.Cena;
        this.JedinicaMere=input.JedinicaMere;
        this.Konto=input.Konto;
        this.Tarifa=input.Tarifa;
        this.TarifaID=input.TarifaID;
        this.JedinicaMereID=input.JedinicaMereID;
       // this.OrgJed=input.OrgJed;
        return this;
    }

    Serialize(input:VrstaStavkiView){
        return input;
    }
}